class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-out`;
    }
    /**
     * Creates a new outbound call out session. Currently this method is supported for Softphone/Hardphone only, since device IDs for WebRTC/Mobile apps cannot be obtained.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/call-out
     * Rate Limit Group: Heavy
     * App Permission: CallControl
     */
    async post(makeCallOutRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), makeCallOutRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
